import { render, staticRenderFns } from "./holddollar-detail.vue?vue&type=template&id=562c22f4&scoped=true&"
import script from "./holddollar-detail.vue?vue&type=script&lang=js&"
export * from "./holddollar-detail.vue?vue&type=script&lang=js&"
import style0 from "./holddollar-detail.vue?vue&type=style&index=0&id=562c22f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562c22f4",
  null
  
)

export default component.exports